import Icon from '../components/Icon.vue'

Icon.register({
  'kiss-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM209 227.9L199.5 210.9C191.8 197.2 180.3 189.3 168 189.3S144.2 197.2 136.5 210.9L127 227.9C122.8 235.3 111.4 231.9 112.1 223.4 115.4 181.3 144.3 152 168.1 152S220.8 181.3 224.1 223.4C224.6 231.9 213.2 235.4 209 227.9zM304 396C304 415.2 275.3 437.5 232.5 440 224 440.8 220.4 428.2 228.9 424.6L245.9 417.4C258.9 411.9 266.7 403.9 266.7 395.9S258.9 379.9 245.9 374.4L228.9 367.2C222.9 364.7 222.8 355 228.9 352.4L245.9 345.2C258.9 339.7 266.7 331.7 266.7 323.7S258.9 307.7 245.9 302.2L228.9 295C220.3 291.4 224.1 278.5 232.5 279.6 275.3 282.1 304 304.4 304 323.6 304 336.6 290.6 350.9 268.8 359.6 290.6 368.7 304 383 304 396zM369 227.9L359.5 210.9C351.8 197.2 340.3 189.3 328 189.3S304.2 197.2 296.5 210.9L287 227.9C282.9 235.2 271.4 231.9 272.1 223.4 275.4 181.3 304.3 152 328.1 152S380.8 181.3 384.1 223.4C384.6 231.9 373.2 235.4 369 227.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/kiss-beam.js
// module id = pfaO
// module chunks = 144